import React from "react";
import { Button, useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import DeleteIcon from "@mui/icons-material/Delete";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";

const DeleteStateExamDialog = ({ studentEducationId, stateExamId, fetchStateExamsResults }) => {
  const notify = useNotify();

  const handleSubmit = async () => {
    await dataProvider.customRequest(
      graduationRequests.stateExamStudentResult(stateExamId, studentEducationId),
      null,
      "DELETE",
    );
    notify("Резултатът е изтрит успешно", { type: "success" });
    fetchStateExamsResults();
  };

  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent="Изтриване на резултат"
      message="Сигурни ли сте, че искате да изтриете резултата на студента?"
      triggerButton={
        <Button
          label="Изтрий резултат"
          startIcon={<DeleteIcon />}
          color="error"
        />
      }
    />
  );
};

export default DeleteStateExamDialog;
